import type { TranslateFn, TranslationKey } from "@/lib/translation";
import type { AppNotification } from "@/api/client/types";

// The backend stores only the type and its values; the text is translated here.
export function notificationText(t: TranslateFn, n: AppNotification) {
  const base = `notifications:items.${n.type}`;
  // Referral rewards pass `months`, which drives the plural like `count` does elsewhere.
  const count = Number(n.params.count ?? n.params.months);
  const options = { ...n.params, count };
  const bodyKey = Number(n.params.more) > 0 ? "bodyMore" : "body";
  return {
    title: t(`${base}.title` as TranslationKey, options),
    body: t(`${base}.${bodyKey}` as TranslationKey, options),
  };
}
